module.exports = __webpack_public_path__ + "static/media/emperor-stone.47d9dc84.png";